export const PROMO_CODE_INPUT_TEST_ID = {
  apply: 'apply-promo-button',
  input: 'promo-code-input',
};
